/* DeleteFolderAction.js */

"use strict";
const _ = require("lodash");

class DeleteFolderAction {
    constructor(logger, gameEditor, modalUserFeedback, activeView, userSession, OsImagePaths) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._osImagePathsEntity = OsImagePaths;

        const pathIdToDelete = _.get(this._activeView.explorerState, "selectedPathId");
        this.run = this.run.bind(this, pathIdToDelete);
    }

    run(pathIdToDelete) {
        if (pathIdToDelete && this._activeView.canEditFolders()) {
            const currentTreeSelectedNode = this._activeView.renderer.selectedPath;
            const treeNodes = this._activeView.renderer._treeComponent.getTreeNodes(),
                deletedNode = treeNodes.find((node) => node.id === pathIdToDelete),
                deletedParentId = _.get(deletedNode, "parent.id", undefined);

            const shouldSwitchToParent = deletedParentId && this.getParentsList(currentTreeSelectedNode).includes(deletedNode.id);

            this._message = `Are you sure you want to permanently delete the "${deletedNode.name}" folder?`;

            return this._gameEditor.runQuickConfirmationActionWorkflow(
                {
                    message: this._message,
                    title: "Delete",
                    confirmDetails: {
                        text: "Confirm",
                        type: "destructive"
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text"
                    }
                },
                () => this._deleteFolder(pathIdToDelete).then(() => shouldSwitchToParent && this._activeView.updateFolderSelection(deletedParentId))
            );
        } else {
            return Promise.resolve();
        }
    }
    /* jshint ignore:start */
    async _deleteFolder(id) {
        let osip = await this._osImagePathsEntity.loadPaths(this._activeOrgId);
        osip.deletePath(id);
        return await osip.update();
    }
    /* jshint ignore:end */

    /**
     *
     * @param node - node to start hierarchy ascension
     * @param {string[]} list - list of node ids from node up to tree root.
     * @return {any}
     */
    getParentsList(node, list = []) {
        list = list.concat(node.id);
        return node.parent ? this.getParentsList(node.parent, list) : list;
    }
}

module.exports = DeleteFolderAction;

DeleteFolderAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.OsImagePaths"
];

DeleteFolderAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    shown: true,
    title: "Delete Folder",
    order: 5
};
